module.exports = __webpack_public_path__ + "img/works_kuraray_miniapp_5.b69c20a3.jpg";